import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 18a1 1 0 0 1-.71-.29l-9-9a1.004 1.004 0 0 1 1.42-1.42l8.29 8.3 8.29-8.3a1.003 1.003 0 1 1 1.42 1.42l-9 9A1 1 0 0 1 12 18"
    />
  </svg>
);
export default SvgChevronDown;
